import qs from 'qs'
import store from '../store'

/**
 *
 * @export - 下载流文件
 * @param {*} res - axios返回的响应，带响应头
 */
export function downloadFile(res) {
  let downLoadUrl = URL.createObjectURL(res.data)
  let disposition = res.headers['content-disposition'].split(';')[1]
  let obj = qs.parse(disposition)
  // 兼容IE和旧版edge
  if (window.navigator.msSaveBlob) {
    window.navigator.msSaveBlob(res.data, obj.filename)
  } else {
    createDownloadElement(downLoadUrl, obj.filename)
    URL.revokeObjectURL(downLoadUrl)
  }
}

/**
 *
 * @export - 创建一个待下载链接的A标签并下载
 * @param {*} url 绝对路径与相对路径
 * @param {*} fileName 下载文件的文件名称
 */
export function createDownloadElement(url, fileName) {
  let a = document.createElement('a')
  a.href = url
  a.download = fileName
  a.style.display = 'none'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  a = null
}

/**
 *
 *
 * @export 通过打开新窗口下载文件，适用于get请求
 * @param {*} url
 * @param {*} params
 */
export function downloadByOpenWindow(url, params) {
  let downloadParams = {
    ...params,
    token: store.state.token
  }
  let origin = location.origin + '/api/' + url + '?' + qs.stringify(downloadParams)
  window.open(origin, '_blank')
}
